import Swal from 'sweetalert2';

export async function AlertaConfirmar(title: string, message: string) {
    const confirm = await Swal.fire({
        title: title,
        text: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
    });

    return confirm.isConfirmed;
}
